/*
 * @Author: your name
 * @Date: 2020-03-05 12:44:51
 * @LastEditTime: 2020-09-25 19:48:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /visa-pc/src/request/base.js
 */
let Base64 = require("js-base64").Base64;
let baseUrl = process.env.SERVER_API
const clientId = "korea_web";
const clientSecret = "webapp";
const baseToken = Base64.encode(`${clientId}:${clientSecret}`);
const baseAuth = "Basic " + baseToken;
const base = {
  baseURL: baseUrl,
  baseAuth: baseAuth,
};
export default base;



// WEBPACK FOOTER //
// ./src/request/base.js